

export const SEND_NOTIFICATION = "SEND_NOTIFICATION";


export const SEND_SELLER_NOTIFICATION = "SEND_SELLER_NOTIFICATION";

